import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTE_PATH from "../../constant/route";
import { urls } from "../../constant/constants";
 

const Payment: React.FC = () => {
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null); // Create a reference for the form
  const userState = useSelector((state: any) => state);
  const dataForPayment = localStorage.getItem("dataForPayment");
  const userData = JSON.parse(dataForPayment || "{}")?.userData;
  const paymentData = JSON.parse(dataForPayment || "{}")?.paymentData;
  const totalPrice = 299;
  const formDetail = userData;
  const prosureCustomerId = JSON.parse(dataForPayment || "{}")?.prosureCustomerId;
  const prodUrl = urls.prodUrl;
  //const partnerDetails= userState?.authentication?.login

 

  const currentUrl = window.location.href;
  const isCoversure = currentUrl.includes(prodUrl!);
  useEffect(() => {
    if (!prosureCustomerId) {
      navigate(ROUTE_PATH.WELLNESS);
    } else {
      if (formRef.current) {
        formRef.current.submit(); // Triggers the form's submit method
      }
    }
  }, []);


  function createSuccessUrl() {
    const url = new URL(window.location.origin + ROUTE_PATH.SUCCESS_PAYMENT);
    // Add query parameters
    url.searchParams.append('paymentData', paymentData?.transactionId);
    url.searchParams.append('name', formDetail?.firstName);
    url.searchParams.append('email', formDetail?.email);
    url.searchParams.append('mobile', formDetail?.mobileNo);
    url.searchParams.append('totalPrice', totalPrice.toString());
    url.searchParams.append('partnerCode', 'ProSure');
    url.searchParams.append('isVerified', "true");
    url.searchParams.append('successUpdate', "false");
    return url.toString();
  }

  function createFailureUrl() {
    const url = new URL(window.location.origin + ROUTE_PATH.FAILURE_PAYMENT);
    // Add query parameters
    url.searchParams.append('name', formDetail?.firstName);
    url.searchParams.append('paymentData', paymentData?.transactionId);
    url.searchParams.append('lastName', formDetail?.lastName || "");
    url.searchParams.append('email', formDetail?.email);
    url.searchParams.append('mobile', formDetail?.mobileNo);
    url.searchParams.append('totalPrice', totalPrice.toString());
    url.searchParams.append('partnerCode', 'ProSure');
    url.searchParams.append('isVerified', "true");
    url.searchParams.append('failedUpdate', "false");
    url.searchParams.append('prosureCustomerId', prosureCustomerId);
    return url.toString();
  }

 

 
  return (
    <>
      <form
        ref={formRef} // Attach the reference to the form element
        action={isCoversure ? urls.payuProd : urls.payuTest}
        method="post"
      >
        <input type="hidden" name="key" value={paymentData?.key} />
        <input type="hidden" name="txnid" value={paymentData?.transactionId} />
        <input type="hidden" name="productinfo" value="ProSure" />
        <input type="hidden" name="amount" value={totalPrice} />
        <input type="hidden" name="email" value={formDetail?.email} />
        <input type="hidden" name="firstName" value={formDetail?.firstName} />
         <input
          type="hidden"
          name="surl"
          value={createSuccessUrl()}
        />
        <input
          type="hidden"
          name="furl"
          value={createFailureUrl()}
        />
        <input type="hidden" name="phone" value={formDetail?.mobileNo} />
        <input
          type="hidden"
          name="hash"
          value={paymentData?.hash}
        />
      </form>
      <div className="w-[100%] h-[100vh] flex items-center justify-center text-[16px] leading-[20px] font-bold">
        Please Wait ...
      </div>
    </>
  );
};

export default Payment;
